  <!-- section begin -->
  <section
    id="subheader"
    class="text-light"
    data-bgimage="url(assets/images/background/10.jpg)"
    data-stellar-background-ratio=".2"
    style="background: url(assets/images/background/16.jpg) 0% 0px / cover; "
  >
    <div class="overlay-bg t50">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Edit Register Form</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- section close -->



  <section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
    <div class="container">

      <button (click)="tests()">test</button>
      <div class="col-md-12">
        <h2>Education Qualification</h2>

        <table style="border: 1px solid;">
          <thead style="border: 1px solid;">
            <tr>
              <th>name of pass</th>
              <th>Year Of pass</th>
              <th>board / university </th>
              <th>Sub Studied</th>
              <th>Marks</th>
            </tr>
          </thead>
          <tbody>
              <tr *ngFor="let i of dash_edu_table">
                <td>{{i.nameofpass}}</td>
                <td>{{i.yearofpass}}</td>
                <td>{{i.board_university}}</td>
                <td>{{i.substudied}}</td>
                <td>{{i.marks}}</td>
              </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body">
        <form [formGroup]="fileUploadForm" (ngSubmit)="onFormSubmit()">







            <div class="form-row">

              <div class="form-group col-12">
                <label>Educational Qualifications</label>
                <table class="table table-bordered" formArrayName="qualificationFa">
                  <thead>
                    <tr>
                      <th> Examinaton</th>
                      <th>Year of Passing</th>
                      <th> Board / University</th>
                      <th>Subject</th>
                      <th>Division / marks %</th>
                      <th> <button type="button" (click)="addQualification()" >Add </button></th>

                    </tr>
                  </thead>
                  <tr>
                    <!-- <th colspan="2">Add Multiple Quantity:</th> -->
                    <!-- <th width="150px"></th> -->
                  </tr>
                  <tr *ngFor="let quantity of qualification().controls; let i=index" [formGroupName]="i">
                    <td>
                        <!-- Quantity : -->
                        <input type="text" formControlName="exampassed" class="form-control" (keypress)="omit_spl($event)" maxlength="50">
                    </td>
                    <td>
                        <!-- Price: -->
                        <input type="text" formControlName="yearpass" (keypress)="omit_number($event)" class="form-control" maxlength="4">
                    </td>
                    <td>
                      <!-- Price: -->
                      <input type="text" formControlName="university" (keypress)="omit_text($event)" class="form-control" maxlength="50">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="substudied"  (keypress)="omit_text($event)" class="form-control" maxlength="50">
                  </td>
                  <td>
                      <!-- Price: -->
                      <input type="text" formControlName="marks" class="form-control"  (keypress)="omit_decimal($event)" class="form-control" maxlength="4">
                  </td>
                    <td>
                        <button *ngIf="i >= 0" (click)="removeQualification(i)" class="btn btn-danger">Remove</button>

                    </td>
                  </tr>
                </table>

              </div>
            </div>

            <hr>




          <button class="btn btn-primary" type="submit">Save and Continue</button>

        </form>
    </div>
    <hr>



  <button class="btn btn-primary" (click)="logout()">Log Out</button>
